import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from "lodash/map";
import shuffle from "lodash/shuffle";
import get from "lodash/get";
import has from "lodash/has";
import ReactDOM from 'react-dom';
import { AvatarUpload } from '../inputs/avatar-upload';
import { Profile } from 'api/api-profile';
import { Navbar } from '../navbar/navbar';
import { FormBuilder } from '../forms/form';
import { PhoneNumberInput } from '../inputs/phone-code-input';
import SelectField from '../reduxForms/fields/SelectField/SelectField';
import { Helpers } from 'shared-components/helpers/helpers';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';


class ProfileForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      modalShow: true,
      errorMsg: null,
      profileData: null,
      needsVerification: true,
      hearAbout: null
    };

    this.updateProfile = this.updateProfile.bind(this);
    this.updateInputCb = this.updateInputCb.bind(this);
    this.updateAvatarCb = this.updateAvatarCb.bind(this);
    this.updatePhoneNumberCb = this.updatePhoneNumberCb.bind(this);
    this.moveToVerificationAction = this.moveToVerificationAction.bind(this);
    this.moveToVerificationAction = this.moveToVerificationAction.bind(this);
    this.closeBehavior = this.closeBehavior.bind(this);
    this.moveToVerificationCb = this.moveToVerificationCb.bind(this);
    this.avatarUploader = this.avatarUploader.bind(this);
    this.renderPhoneNumberInput = this.renderPhoneNumberInput.bind(this);
    this.renderProfileFormBuilder = this.renderProfileFormBuilder.bind(this);
    this.renderHearAboutDropdown = this.renderHearAboutDropdown.bind(this);
    this.changeHearAboutDropdown = this.changeHearAboutDropdown.bind(this);
  }

  componentWillMount () {
    const ssoId = $('#main-nav').data('usr');
    const accessToken = PSSessions.Cookies('PSAccess');
    const profilePath = '/v1/profiles/me';

    // If the user signs up via social, we automatically verify their email
    // thus ending the need for the email verification modal.
    return Profile.read(profilePath, accessToken, (user) => {
      if (user.email_verified) {
        this.setState({ profileData: user, needsVerification: false });
      } else {
        this.setState({ profileData: user, needsVerification: true });
      }
    });
  }

  componentDidMount () {
    if (analyticsIntegrations) {
      analyticsIntegrations.signupForm('signup profile form viewed', { source: this.props.source });
    }
  }

  // Update action for Profile
  updateProfile (profileBody, callback) {
    const ssoId = 'me';
    const accessToken = PSSessions.Cookies('PSAccess');
    let profileObj = profileBody;
    profileObj.ga_client_id = analyticsIntegrations.getGoogleAnalyticsID();
    Profile.update(ssoId, accessToken, profileObj, callback);
  }

  // Callback function for all input fields except for the avatar uploader
  // This function must include errorData,
  // validState, invalidCbState as the arguments
  updateInputCb (errorData, validState, invalidCbState, response) {
    if (response.error) {
      let errorMsg = response.error_description;
      if (response.statusCode > 400 ) {
        invalidCbState(errorData, errorMsg);
      }
    } else {
      if (this.state.modalShow) {
        validState(errorData);
      }

      this.setState({
        profileData: response.profile
      });

      analyticsIntegrations.updateProfile(response);
    }
  }

  // Callback funciton for just the avatar uploader
  // This function must include croppedProfileURL, setImgState, setErrorState
  // as the arguments
  updateAvatarCb (croppedProfileURL, setImgState,
    setErrorState, response) {
    if (response.error) {
      let errorMsg = response.error_description;
      if (response.statusCode > 400 ) {
        setErrorState(errorMsg);
      }
    } else {
      if (this.state.modalShow) {
        setImgState(croppedProfileURL);
      }

      this.setState({
        profileData: response.profile
      });

      analyticsIntegrations.updateProfile(response);
      if (!this.props.isSignupPage) {
        Navbar.refreshUserInfo(true);
      }
    }
  }

  updatePhoneNumberCb (setErrorState, response) {
    if (response.error) {
      let errorMsg = response.error_description;
      if (response.statusCode > 400 ) {
        setErrorState(errorMsg);
      }
    } else {
      this.setState({
        profileData: response.profile
      });

      analyticsIntegrations.updateProfile(response);
    }
  }
  // Function to move modal to verification modal after user
  // clicks 'Complete Profile' the callback will trigger
  // changing of states inside of signup-manager.jsx
  moveToVerificationAction (e, callback) {
    callback();
  }

  closeBehavior () {
    this.props.closeFn();
  }

  // Callback for moveToVerificationAction
  moveToVerificationCb () {
    const { needsVerification, profileData } = this.state;
    if (analyticsIntegrations) {
      analyticsIntegrations.signupForm(
        'signup profile form submitted',
        { source: this.props.source },
        { ...profileData, heard_about_us: this.state.hearAbout }
      );
    }

    this.setState({ modalShow: false });
    if (!this.props.isSignupPage && !needsVerification) {
      return this.closeBehavior();
    }

    return this.props.callbackFn();
  }

  avatarUploader () {
    // defaultAvatar: prefilled image from the user's FB
    // when AvatarUpload loads it immediately gets sent to Cloudinary on componentWillMount

    // avatarUrl: is for images that are already on Cloudinary
    // we want to bypass the Cloudinary creation when the AvatarUpload component uploads

    const { prefilledData } = this.props;
    return (<AvatarUpload
      key="avatar_url"
      ref="avatar"
      defaultAvatar={prefilledData ? prefilledData.avatar : ''}
      avatarUrl={prefilledData ? prefilledData.avatar_url : ''}
      actionFn={this.updateProfile}
      actionCb={this.updateAvatarCb}
      horizontalView
    />);
  }

  renderPhoneNumberInput () {
    const { prefilledData } = this.props;
    const phone = get(prefilledData, 'phone', '');
    const country = get(prefilledData, 'phone_country', '');

    return (
      <div>
        <label htmlFor="phone-input" className="col-xs-12 control-label text-left no-gutter">
          <FormattedMessage
            id="shared_components.profile_form.phone_number"
            defaultMessage="Phone Number"
          />
        </label>
        <PhoneNumberInput
          key="phone_number"
          ref="phone"
          actionFn={this.updateProfile}
          actionCb={this.updatePhoneNumberCb}
          inputColSize="col-xs-12 no-gutter margin-md-bottom"
          defaultVal={phone}
          defaultCountry={country}
          optional
        />
      </div>
    );
  }

  changeHearAboutDropdown (newValue) {
    this.setState({ hearAbout: newValue });
  }

  renderHearAboutDropdown () {
    const options = defineMessages({
      online_search: {
        id: 'shared_components.profile_form.online_search',
        defaultMessage: 'Online search'
      },
      social_media: {
        id: 'shared_components.profile_form.social_media',
        defaultMessage: 'Social media'
      },
      peerspace_location: {
        id: 'shared_components.profile_form.peerspace_location',
        defaultMessage: 'Was in a Peerspace location'
      },
      friend_family: {
        id: 'shared_components.profile_form.friend_family',
        defaultMessage: 'Friend or family'
      },
      peerspace_contacted: {
        id: 'shared_components.profile_form.peerspace_contacted',
        defaultMessage: 'Peerspace contacted me'
      },
      radio_tv: {
        id: 'shared_components.profile_form.radio_tv',
        defaultMessage: 'Radio or television'
      }
    });

    const otherOptions = defineMessages({
      other: {
        id: 'shared_components.profile_form.other',
        defaultMessage: 'Other'
      }
    });

    const selectFieldOptions = map(
      [
        ...shuffle(Object.keys(options)),
        Object.keys(otherOptions)
      ],
      (key = '') => {
        const option = options[key] || otherOptions[key];
        return {
          label: this.props.intl.formatMessage({ ...option }),
          value: option.defaultMessage
        };
      });

    const input = {
      name: 'hearAbout',
      value: this.state.hearAbout,
      onChange: this.changeHearAboutDropdown
    };

    return (
      <div className="hear-about-container">
        <label htmlFor="hear-about-input" className="col-xs-12 control-label text-left no-gutter">
          <FormattedMessage
            id="shared_components.profile_form.heard_about_us"
            defaultMessage="How did you hear about us?"
          />
        </label>
        <SelectField
          id="how-did-you-hear-about"
          options={selectFieldOptions}
          input={input}
          placeholder={this.props.intl.formatMessage({
            id: 'shared_components.profile_form.select_option',
            defaultMessage: 'Select Option'
          })}
          className="col-xs-12 no-gutter open-upwards-zindex"
          menuPlacement="top"
          isMobile={Helpers.isMobile()}
        />
      </div>
    );
  }

  renderProfileFormBuilder () {
    const { prefilledData } = this.props;

    let first_name;
    let last_name;
    let organization;
    let job_title;
    let avatar;

    if (prefilledData) {
      first_name = prefilledData.first_name;
      last_name= prefilledData.last_name;
      organization = prefilledData.organization;
      job_title = prefilledData.job_title || prefilledData.profession;
      avatar = prefilledData.avatar;
    }

    const profileFormInputMetaData = [
      [{ custom: this.avatarUploader }],
      [
        {
          inputFieldName: "first_name",
          elementID: "first_name",
          ref: "firstName",
          optional: false,
          defaultVal: first_name || null,
          label: <div><FormattedMessage id="shared_components.profile_form.first_name" defaultMessage="First Name" /><span className="required">*</span></div>,
          hideRequired: true,
          labelSize: 'col-xs-12',
          actionFn: this.updateProfile,
          actionCb: this.updateInputCb,
          colSize: 'col-sm-6 col-xs-12 half-padding-right no-gutter margin-lg-bottom',
          placeholder: ' ',
          instantCheckForError: has(prefilledData, 'first_name'),
        },
        {
          inputFieldName: "last_name",
          elementID: "last_name",
          ref: "lastName",
          optional: false,
          defaultVal: last_name || null,
          label: <div><FormattedMessage id="shared_components.profile_form.last_name" defaultMessage="Last Name" /><span className="required">*</span></div>,
          hideRequired: true,
          labelSize: 'col-xs-12',
          actionFn: this.updateProfile,
          actionCb: this.updateInputCb,
          colSize: 'col-sm-6 col-xs-12 half-padding-left no-gutter margin-lg-bottom',
          placeholder: ' ',
          instantCheckForError: has(prefilledData, 'last_name'),
        }
      ],
      [
        {
          inputFieldName: "organization",
          elementID: "organization",
          optional: true,
          defaultVal: organization || null,
          label: <FormattedMessage id="shared_components.profile_form.company_name" defaultMessage="Company Name" />,
          labelSize: 'col-xs-12',
          ref: "organization",
          actionFn: this.updateProfile,
          actionCb: this.updateInputCb,
          colSize: 'col-sm-6 col-xs-12 half-padding-right no-gutter margin-lg-bottom',
          placeholder: ' '
        },
        {
          inputFieldName: "job_title",
          elementID: "profession",
          optional: true,
          defaultVal: job_title || null,
          label: <FormattedMessage id="shared_components.profile_form.job_title" defaultMessage="Job Title" />,
          labelSize: 'col-xs-12',
          ref: "jobTitle",
          actionFn: this.updateProfile,
          actionCb: this.updateInputCb,
          colSize: 'col-sm-6 col-xs-12 half-padding-left no-gutter margin-lg-bottom',
          placeholder: ' '
        }
      ],
      [{ custom: this.renderPhoneNumberInput }],
      ...[!this.props.isSignupPage && this.renderHearAboutDropdown()]
    ];

    return (
      <FormBuilder
        ctaButtonAttributes={{ 'data-testing-id': 'complete-profile' }}
        ref="profileForm"
        formname="profile form"
        formStyle=""
        formClassString="profile-form-container"
        formGroups={profileFormInputMetaData}
        errorText={this.state.errorMsg}
        submitAction={this.moveToVerificationAction}
        submitCallback={this.moveToVerificationCb}
        isButtonDisabled={false}
        btnColSize="col-xs-12 no-gutter"
        buttonText={ <FormattedMessage id="shared_components.profile_form.complete_profile" defaultMessage="Complete Profile" /> }
        buttonClass="btn btn-lg btn-primary profile-form-button form"
        extended
      />
    );
  }

  render () {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-12">
            {this.renderProfileFormBuilder()}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(ProfileForm);

ProfileForm.propTypes = {
  isSignupPage: PropTypes.bool,
  callbackFn: PropTypes.func,
  prefilledData: PropTypes.shape({
    email: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    organization: PropTypes.string,
    job_title: PropTypes.string,
    avatar: PropTypes.string,
    fbId: PropTypes.string
  }),
  source: PropTypes.string
};
